import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip, Button, Dialog, DialogActions, DialogContent, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Form from '../Form/Form';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import useStyles from './styles';
import { createPost, updatePost } from '../../actions/posts';

export default function FormDialog({
  currentId,
  setCurrentId,
  handleClickOpen,
  handleClose,
  open, about
}) {
  const [postData, setPostData] = useState({ creator: '', title: '', message: '', tags: '', selectedFile: '' });
  const post = useSelector((state) => (currentId ? state.posts.find((message) => message._id === currentId) : null));
  const dispatch = useDispatch();
  const classes = useStyles();

  useEffect(() => { if (post) setPostData(post); }, [post]);

  const clear = () => {
    setCurrentId(0);
    setPostData({ title: '', selectedFile: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (currentId === 0) {
      dispatch(createPost(postData));
      clear();
    } else {
      dispatch(updatePost(currentId, postData));
      clear();
    }
  };

  return (
    <div >
      <Tooltip data-title="Add New" title="">
        <Button color="primary" onClick={handleClickOpen}>
          <BorderColorIcon /> Add New
        </Button>
      </Tooltip>
      <Dialog open={open} onClose={() => { handleClose(); clear(); }}  >
        <DialogActions>
          <Button onClick={() => { handleClose(); clear(); }}><CloseIcon /></Button>
        </DialogActions>
        <DialogContent>
          {about ?
            <Typography variant="p" align="center">This is a responsive designed CRUD full stack project, frontend Reactjs, redux, meterialUI style, backend nodejs, restfulAPI, interact with mongoDB, deployed heroku and netlify. Feel free to test add new, edit and delete, any questions please let me know.</Typography>
            : <Form
              currentId={currentId}
              handleClose={handleClose}
              clear={clear}
              handleSubmit={handleSubmit}
              post={post}
              postData={postData}
              setPostData={setPostData}
            />}
        </DialogContent>
        <Typography className={classes.dialogbottom}>xu.megan@hotmail.com</Typography>
      </Dialog>
    </div>
  );
}
